import { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "分类", path: "/category/remen" },
  { name: "排行榜", path: "/#ranking" },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-xl md:text-2xl text-background-50"></i>
            </span>
            <span
              className={`text-xl md:text-2xl font-bold font-heading transition-colors duration-300 ${
                isScrolled || !isHome
                  ? "text-foreground-900"
                  : "text-background-50"
              }`}
            >
              午马影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? "bg-primary-500/10 text-primary-600"
                    : isScrolled || !isHome
                      ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-500/5"
                      : "text-background-50/90 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div
              className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all duration-300 cursor-pointer ${
                isScrolled || !isHome
                  ? "bg-background-100 text-foreground-500 hover:text-foreground-700"
                  : "bg-white/10 text-background-50/80 hover:text-background-50 hover:bg-white/20"
              }`}
            >
              <i className="ri-search-line text-sm"></i>
              <span className="text-sm whitespace-nowrap">搜索剧集...</span>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors duration-300 hover:bg-white/10"
            aria-label="菜单"
          >
            <i
              className={`text-2xl transition-colors duration-300 ${
                isScrolled || !isHome
                  ? "text-foreground-800"
                  : "text-background-50"
              } ${
                mobileOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 rounded-xl mx-auto max-w-[1400px] mb-3 shadow-lg border border-background-200/70 overflow-hidden animate-[fadeIn_0.2s_ease-out]">
            <div className="p-4 space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path
                      ? "bg-primary-500/10 text-primary-600"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-100 text-foreground-500 cursor-pointer">
                <i className="ri-search-line text-sm"></i>
                <span className="text-sm whitespace-nowrap">搜索剧集...</span>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}